interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

function buildPages(current: number, total: number): (number | string)[] {
  const pages: (number | string)[] = [];
  if (total <= 7) {
    for (let i = 1; i <= total; i += 1) pages.push(i);
    return pages;
  }
  pages.push(1);
  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);
  if (start > 2) pages.push("start-ellipsis");
  for (let i = start; i <= end; i += 1) pages.push(i);
  if (end < total - 1) pages.push("end-ellipsis");
  pages.push(total);
  return pages;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;
  const pages = buildPages(current, total);

  const go = (page: number) => {
    if (page < 1 || page > total || page === current) return;
    onChange(page);
  };

  return (
    <nav aria-label="分页导航" className="flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        onClick={() => go(current - 1)}
        disabled={current === 1}
        className="flex h-9 items-center gap-1 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-3 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </button>

      {pages.map((page) =>
        typeof page === "number" ? (
          <button
            key={page}
            type="button"
            onClick={() => go(page)}
            aria-current={page === current ? "page" : undefined}
            className={`flex h-9 w-9 items-center justify-center rounded-md text-sm transition-colors ${
              page === current
                ? "bg-primary-500 font-medium text-background-50"
                : "border border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
            }`}
          >
            {page}
          </button>
        ) : (
          <span key={page} className="px-1 text-foreground-400">
            …
          </span>
        )
      )}

      <button
        type="button"
        onClick={() => go(current + 1)}
        disabled={current === total}
        className="flex h-9 items-center gap-1 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-3 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </nav>
  );
}